import { IRiskLevelProposal } from "@portal/types/robot/IRiskLevelProposal";

export const IsAskEnabled = (riskLevelProposal: IRiskLevelProposal[] | undefined) => {
  if (!riskLevelProposal) return false;

  const selectedRiskAppetite = riskLevelProposal.find(proposal => proposal.default);
  const shares = selectedRiskAppetite?.shares ?? 0;
  const minimumShares = 80;

  return shares >= minimumShares;
};
